import React from "react";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>📻 NOBLE 94 DIGITAL © 2025</p>
      <div className="social-icons">
        <a href="#" target="_blank"><FaFacebook /></a>
        <a href="#" target="_blank"><FaTwitter /></a>
        <a href="#" target="_blank"><FaInstagram /></a>
      </div>
    </footer>
  );
};

export default Footer;
